import clsx from "clsx";
import React, {
  CSSProperties,
  FunctionComponent,
  LegacyRef,
  PropsWithChildren
} from "react";
import { DropdownFilter } from "../../../../../components";
import {
  DropdownFilterDataProps,
  MenuItems
} from "../../../../../components/DropdownFilter";
import cardStyles from "../../../../../components/subheader/card/card.module.scss";
import Typography from "../../../../../components/typography/Typography";
import { IWithFilter } from "../../../../../hooks/useWithFilter";

type CardSelectToggleProps = {
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  title: string;
  disabled: boolean;
};

const SelectToggle: FunctionComponent<
  PropsWithChildren<CardSelectToggleProps>
> = React.forwardRef(({ children, onClick, title, disabled }, ref) => {
  const [, label, indicator] = children as React.ReactNode[];

  return (
    <div
      ref={ref as LegacyRef<HTMLDivElement>}
      onClick={e => {
        e.preventDefault();

        if (!disabled) {
          onClick(e);
        }
      }}
      className={clsx("d-flex justify-content-between p-15", {
        "background-color-disabled": disabled,
        "cursor-default": disabled
      })}
    >
      <div>
        <Typography
          variant={"subtitle6"}
          className={"text-color-gray-60 text-uppercase"}
          style={{ fontSize: 10 }}
        >
          {title}
        </Typography>
        <Typography variant={"subtitle6"}>{label}</Typography>
      </div>
      {indicator}
    </div>
  );
});

type ReanalyzeDropdownProps<T> = {
  filterValue?: T;
  filterTitle: string;
  fieldName: string;
  options: MenuItems<T>;
  className?: string;
  menuStyles?: CSSProperties;
  formatLabel?: (item: DropdownFilterDataProps<T>) => JSX.Element;
  disabled?: boolean;
} & IWithFilter<T>;

const ReanalyzeDropdown = <T,>({
  filterValue,
  filterTitle,
  fieldName,
  options,
  className,
  menuStyles,
  onFilterChange,
  formatLabel,
  disabled
}: ReanalyzeDropdownProps<T>) => {
  const title = options?.find(option => option.value === filterValue)?.label;

  return (
    <DropdownFilter
      CustomDropdownToggleComponent={SelectToggle}
      value={filterValue}
      field={fieldName}
      menuItems={options}
      dropdownToggleTitle={filterTitle}
      title={title ?? "--"}
      containerClassName={clsx(
        "cursor-pointer",
        cardStyles.card_hoverable,
        className
      )}
      styles={{
        menu: menuStyles
      }}
      onFilterChange={onFilterChange}
      formatLabel={formatLabel}
      disabled={disabled}
    />
  );
};

export default ReanalyzeDropdown;
